import { Box } from "@mui/material";
import type { FC } from "react";
import { REMINDERS_SECTION_ANCHOR_ID } from "web_myplann/NotificationCenter/Utils/reminderScrollParam";
import { useScrollToReminders } from "web_myplann/Portfolio/Hooks/useScrollToReminders";
import { RemindersSection } from "web_myplann/Reminders/Components/RemindersSection";
import type { ReminderEntity } from "web_myplann/Reminders/Types/ReminderTypes";

type Props = {
	entity: ReminderEntity;
};

export const DetailRemindersSection: FC<Props> = ({ entity }) => {
	useScrollToReminders(true);

	return (
		<Box
			id={REMINDERS_SECTION_ANCHOR_ID}
			sx={{ "&:empty": { display: "none" } }}
		>
			<RemindersSection entity={entity} />
		</Box>
	);
};
